import { createStore, createEvent } from 'effector';
import { Me, MeError } from './types';

export const setUser = createEvent<Me>();
export const setUserError = createEvent<MeError>();
export const setUserLoading = createEvent<boolean>();
export const userLogout = createEvent();

export const $user = createStore<Me>(null)
  .on(setUser, (_, user) => user)
  .reset(userLogout);
export const $userError = createStore<MeError>(null).on(setUserError, (_, error) => error);
export const $userLoading = createStore<boolean>(true).on(setUserLoading, (_, loading) => loading);
